import { lazy } from 'react'
import { ShopifySectionComponent } from '@/types/ShopifySectionComponent'
import { VacanciesData } from '../../v1/components/Vacancies/types'

const VacanciesV1 = lazy(async () => ({
  default: (await import('../../v1/components/Vacancies/Vacancies')).Vacancies,
}))

const VacanciesV2 = lazy(async () => ({
  default: (await import('../../v2/components/Vacancies/Vacancies')).Vacancies,
}))

import { useFeatureFlags } from '@/hooks/useFeatureFlags'

export const Vacancies: ShopifySectionComponent<VacanciesData> = ({
  data: schema,
  ...queryOptions
}) => {
  const { getFlag } = useFeatureFlags()
  const isCareersV2Enabled = getFlag('careers_v2_endpoint')

  if (isCareersV2Enabled) {
    return <VacanciesV2 data={schema} {...queryOptions} />
  }

  return <VacanciesV1 data={schema} {...queryOptions} />
}
